import { render, staticRenderFns } from "./Participants.vue?vue&type=template&id=20a18b6c&scoped=true"
import script from "./Participants.vue?vue&type=script&lang=js"
export * from "./Participants.vue?vue&type=script&lang=js"
import style0 from "./Participants.vue?vue&type=style&index=0&id=20a18b6c&prod&lang=scss&scoped=true"
import style1 from "./Participants.vue?vue&type=style&index=1&id=20a18b6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a18b6c",
  null
  
)

export default component.exports